import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Select, Tooltip } from "antd";
import { filterOption } from "../../utils/filterOption";
import { fetchSTJobTags } from "../../redux/organizationSlice";

const ProvidersTags = ({ 
  tagIds = [], 
  onTagChange, 
  loading = false,
  showSyncButton = true,
  placeholder = "Select job tags",
  style = { width: "100%" }
}) => {
  const { serviceTitanJobTags, organizationData } = useSelector(
    (state) => state?.organization
  );

  const dispatch = useDispatch()

  const syncJobTags = () => {
    dispatch(fetchSTJobTags(organizationData._id));
  };

  return (
    <div className="w-full flex flex-col items-start gap-2">
      <Tooltip
        styles={{ width: "100%" }}
        title={null}
      >
        <Select
          showSearch
          mode="multiple"
          disabled={loading}
          placeholder={placeholder}
          style={{ ...style, padding: "5px" }}
          loading={loading}
          options={
            serviceTitanJobTags?.data
              ? serviceTitanJobTags.data.map((item) => ({
                  label: item.name,
                  value: organizationData?.organization_provider === 'HCP' ? item.name : String(item.id),
                  desc: item.name,
                }))
              : []
          }
          filterOption={filterOption}
          value={
            serviceTitanJobTags?.data
              ? serviceTitanJobTags.data
                  .filter((item) => {
                    if (organizationData?.organization_provider === 'HCP') {
                      return tagIds?.includes(item.name);
                    }
                    const tagIdStr = String(item.id);
                    return tagIds?.some(tag => String(tag) === tagIdStr);
                  })
                  .map((data) => 
                    organizationData?.organization_provider === 'HCP'
                      ? data.name
                      : String(data.id)
                  ) ?? []
              : []
          }
          onChange={onTagChange}
          size="middle"
        />
      </Tooltip>
      
      {showSyncButton && (
        <>
          <Button
            style={{ width: "100%", marginTop: 10 }}
            title="Sync Job Tags"
            loading={loading}
            size="middle"
            onClick={syncJobTags}
          >
            Sync Tags
          </Button>
          <p className="text-sm text-gray-400">
            Sync tags to ensure you have the latest updates from{" "}
             {organizationData?.organization_provider === 'HCP'?"House Call Pro":"ServiceTitan"}, including any changes in tag status (activate or
            deactivate).
          </p>
        </>
      )}
    </div>
  );
};

export default ProvidersTags;